import dateService from "../../../../common/utils/date/date.service";
import DelegationDetailsRouteWaypoint from "../common/types/delegation-details-route-waypoint";

const getDateLabel = (date: Date | undefined): string => {
  if (!date) {
    return ``;
  }

  return dateService.formatDateTime(date);
};

const generateWaypointDotClassname = (
  waypoint: DelegationDetailsRouteWaypoint,
  index: number,
  delegationUuid: string,
) => {
  return `dot-mileage-${delegationUuid}-coordinates-${waypoint.place.lat};${waypoint.place.lon}-stageNo-${waypoint.stageNo}-index-${index}`;
};

const delegationDetailsRouteHelper = {
  getDateLabel,
  generateWaypointDotClassname,
};

export default delegationDetailsRouteHelper;
